import React from 'react'
import PropTypes from 'prop-types'
import { TabPane, Button } from 'reactstrap'
import get from 'lodash/get'
import set from 'lodash/set'
import moment from '../../../../lib/moment.js'
import styled from 'styled-components'
import { StickyContainer, Sticky } from 'react-sticky'
import { Searchbar } from '../../search-bar'
import { Statusbar } from '../../status-bar'
import { CategoryButton } from './category-button'
import RemarkRow from './remark-row'
import InfoModal from './info-modal'
import RemarkModal from './remark-modal'
import LegendsModal from './legends-modal'
import { ApprovalTable } from './table'
import { HourRow } from './hour-row'
import { DataRow } from './data-row'
import { DataRowMobile } from './data-row-mobile'
import { StatusRow } from './status-row'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'
import { Leave } from '../../form/show-leave'
import { Compensate } from '../../form/show-compensate'
import { Holiday } from '../../form/show-holiday'
import { ApproveTimesheetForm } from '../../form/approve-timesheet'

export const TimesheetApproval = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'path') === undefined) {
      set(tempState, 'searchApprovalDetail', '')
    }
    return tempState
  }

  state={
    filterButton: 3,
    searchApprovalDetail: '',
    isClickApproveOrReject: false,
    tempSearch: get(this.props, 'searchApproval'),
    showInfomation: false,
    showRemark: false,
    showLegends: false,
  }

  clickApproveOrReject = (isApprove) => {
    this.setState({
      isApprove,
      isClickApproveOrReject: !this.state.isClickApproveOrReject,
      remark: '',
    })
  }

  handleRemark = (e) => {
    this.setState({ remark: e.target.value })
  }

  handleClickButton = (isApprove) => {
    const approveTimesheet = get(this.props, 'approveTimesheet')
    const requestID = get(this.props, 'timesheetRequest.timesheetRequest._id')
    const payload = { remark: this.state.remark }
    if (isApprove === 'approve') {
      payload.is_approve = true
      approveTimesheet(requestID, payload)
    } else if (isApprove === 'reject') {
      payload.is_approve = false
      approveTimesheet(requestID, payload)
    }
    this.setState({
      isClickApproveOrReject: !this.state.isClickApproveOrReject,
      remark: '',
    })
  }

  clickFilterButton = (filterButton) => {
    this.setState({ filterButton })
  }

  showRequestDetail = (dataType, data) => {
    if (dataType === CONSTANTS.HOLIDAY || dataType === CONSTANTS.COMPENSATE) {
      this.setState({ dataType, data: this.changeDataFormat(dataType, data) })
    } else {
      this.setState({ dataType: CONSTANTS.LEAVE, data: this.changeDataFormat(dataType, data) })
    }
  }

  changeDataFormat = (dataType, data) => {
    switch (dataType) {
      case CONSTANTS.HOLIDAY: {
        const holiday = {}
        holiday.holiday_name = get(data, 'description')
        return holiday
      }
      case CONSTANTS.COMPENSATE: {
        const users = get(this.props, 'timesheets.users', [])
        const projects = get(this.props, 'timesheets.projects', [])
        const compensates = []

        data.map(d => {
          const compensate = {}
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const project = timesheetHelper.findUserData(get(d, 'project_id'), projects)
          compensate.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          compensate.project = project ? `${project.project_code} - ${project.name}` : '-'
          compensate.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          compensate.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          compensate.working_time = get(d, 'compensate_time')
          compensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          compensate.status = get(d, 'status')
          compensate.remark_request_user = get(d, 'remark_request_user')
          compensate.remark_approver = get(d, 'remark_approver')
          compensate.remark_cancel = get(d, 'remark_cancel')
          compensates.push(compensate)
          return d
        })
        return compensates
      }
      default: {
        const users = get(this.props, 'timesheets.users', [])
        const leaveTypes = get(this.props, 'leaveTypes', [])
        const leaves = []

        data.map(d => {
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const leave_type = timesheetHelper.findUserData(get(d, 'leave_type_id'), leaveTypes)
          const leave = {}
          leave.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          leave.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          leave.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          leave.leave_type = get(leave_type, 'name')
          leave.leave_time = get(d, 'leave_time')
          leave.created = moment(get(d, 'created')).format('DD/MM/YYYY')
          leave.days = get(d, 'days')
          leave.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          leave.status = get(d, 'status')
          leave.attachment_url = get(d, 'attachment_url')
          leave.remark_request_user = get(d, 'remark_request_user')
          leave.remark_approver = get(d, 'remark_approver')
          leave.remark_hr = get(d, 'remark_hr')
          leave.remark_cancel = get(d, 'remark_cancel')
          leaves.push(leave)
          return d
        })
        return leaves
      }
    }
  }

  handleClickCell = (dataType, data) => {
    this.setState({ showDetail: !this.state.showDetail })
    if (!this.state.showDetail) {
      this.showRequestDetail(dataType, data)
    } else {
      this.setState({ dataType: null, data: {} })
    }
  }

  openInfo = () => {
    this.setState({ showInfomation: !this.state.showInfomation })
  }

  openRemark = () => {
    this.setState({ showRemark: !this.state.showRemark })
  }

  openLegends = () => {
    this.setState({ showLegends: !this.state.showLegends })
  }

  render() {
    const { handleClickRequestRow } = this.props
    const timesheetRequest = get(this.props, 'timesheetRequest')
    const can_approve = get(timesheetRequest, 'timesheetRequest.can_approve')

    switch (get(this.props, 'location', '')) {
      case `/time_sheet/approval/${get(this.props, 'path')}` : {
        return (
          <TabPane tabId={ 4 }>
            <Content>
              <Leave
                showDetail={ this.state.dataType === CONSTANTS.LEAVE }
                handleDetail={ this.handleClickCell }
                data={ this.state.data }
              />
              <Compensate
                showDetail={ this.state.dataType === CONSTANTS.COMPENSATE }
                handleDetail={ this.handleClickCell }
                data={ this.state.data }
              />
              <Holiday
                showDetail={ this.state.dataType === CONSTANTS.HOLIDAY }
                handleDetail={ this.handleClickCell }
                { ...this.state.data }
              />
              <InfoModal
                timesheetRequest={ get(this.props, 'timesheetRequest') }
                toggle={ this.openInfo }
                open={ this.state.showInfomation }
              />
              <RemarkModal
                timesheets={ get(this.props, 'timesheets') }
                timesheetRequest={ get(this.props, 'timesheetRequest') }
                toggle={ this.openRemark }
                open={ this.state.showRemark }
              />
              <LegendsModal
                toggle={ this.openLegends }
                open={ this.state.showLegends }
              />
              <StickyContainer className="container relative">
                <Statusbar { ...this.props } />
                <RemarkRow { ...this.props } />
                <div
                  className="gap tall"
                >
                  <Sticky relative={ true }>
                    {({ style }) => (
                      <Div style={ style }>
                        <Searchbar
                          { ...this.props }
                          searchApprovalDetail={ this.state.searchApprovalDetail }
                          handleSearch={ (e) => this.setState({ searchApprovalDetail: e }) }
                          openInfo={ this.openInfo }
                          openRemark={ this.openRemark }
                          openLegends={ this.openLegends }
                        />
                      </Div>
                    )}
                  </Sticky>
                  <HourRow { ...this.props } />
                  <DataRow
                    { ...this.props }
                    searchApprovalDetail={ this.state.searchApprovalDetail }
                    handleClickCell={ this.handleClickCell }
                  />
                  {/* timesheet mobile */}
                  <ContentCol>
                    <DataRowMobile
                      { ...this.props }
                      searchApprovalDetail={ this.state.searchApprovalDetail }
                      handleClickCell={ this.handleClickCell }
                    />
                    <ButtonContent>
                      { can_approve &&
                        <GroupButton>
                          <SaveButton
                            onClick={ () => this.clickApproveOrReject('approve') }
                          >Approve</SaveButton>
                          <OtherButton
                            onClick={ () => this.clickApproveOrReject('reject') }
                          >Reject</OtherButton>
                        </GroupButton>
                      }
                    </ButtonContent>
                  </ContentCol>
                  {/* timesheet mobile */}
                  <ApproveTimesheetForm
                    isApprove={ this.state.isApprove }
                    open={ this.state.isClickApproveOrReject }
                    handleRemark={ (e) => this.handleRemark(e) }
                    handleClickButton={ (isApprove) => this.handleClickButton(isApprove) }
                    clickApproveOrReject={ (type) => this.clickApproveOrReject(type) }
                  />
                  <StatusRow />
                </div>
              </StickyContainer>
            </Content>
          </TabPane>
        )
      }
      default: {
        return (
          <TabPane tabId={ 4 }>
            <CategoryButton
              { ...this.props }
              { ...this.state }
              clickFilterButton={ this.clickFilterButton }
              filterButton={ this.state.filterButton }
            />
            <ApprovalTable
              { ...this.props }
              { ...this.state }
              handleClickRow={ (id) => handleClickRequestRow(id) }
            />
          </TabPane>
        )
      }
    }
  }
}

TimesheetApproval.propTypes = {
  handleClickRequestRow: PropTypes.func,
}
TimesheetApproval.defaultProps = {
  handleClickRequestRow: () => {},
}
const Content = styled.div`
  height: calc(100vh - 120px);
  overflow-y: scroll;
  @media (max-width: 575.98px) {
    padding-bottom: 60px ;
    height: 100vh;
  }
  @media (max-width: 767.98px) {
    padding-bottom: 60px ;
    height: 100vh;
  }
  .container {
    height: calc(100vh - 125px);
    background: #EEEEEE;
    max-width: 100% ;
  }
  .gap.tall {
    height: 100%;
  }
  .container.relative {
    overflow-y: auto;
    margin: 0px;
    padding: 0px;
  }
`
const ContentCol = styled.div`
  @media (max-width: 575.98px) {
    height: 90%;
    margin-bottom: 5%;
    overflow-x: hidden;
  }
  @media (max-width: 767.98px) {
    height: 90%;
    margin-bottom: 5%;
    overflow-x: hidden;
  }
`
const Div = styled.div`
  height: 40px;
  top: 120px !important;
  z-index: 2 !important;
  background: #EEEEEE;
  @media (max-width: 575.98px) {
    top: 90px !important;
  }
  @media (max-width: 767.98px) {
    top: 90px !important;
  }
`
const ButtonContent = styled.div`
  background-color: #ffffff;
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
  margin-bottom: 5%;
  @media (min-width: 768px) {
    display:none;
  }
  @media (min-width: 992px) {
      display:none;
  }
  @media (min-width: 1200px) {
    display:none;
  }
`
const GroupButton = styled.div`
  background-color: #ffffff;
  width: 90%;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
`
const OtherButton = styled(Button)`
  background-color: #D44B49;
  height: 100%;
  width: 50%;
  border: none;
`
const SaveButton = styled(Button)`
  background-color: #5CB85C;
  height: 100%;
  width: 50%;
  margin-right: 5%;
  border: none;
`




// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/index.js